// Helpers para resolver URLs de fotos enviadas (uploads/fotos) tanto em dev
// (proxy /api) quanto em produção (API em host separado).

function getApiBaseUrl() {
  const envUrl = import.meta.env.VITE_API_URL ?? '/api';
  return envUrl.replace(/\/$/, '');
}

export function toAbsoluteFotoUrl(url: string): string {
  if (!url) return '';
  if (url.startsWith('http://') || url.startsWith('https://')) return url;

  const apiBase = getApiBaseUrl();
  const apiOrigin = apiBase.startsWith('http') ? apiBase.replace(/\/api$/, '') : '';

  if (url.startsWith('/api/')) {
    if (apiBase.startsWith('http')) return `${apiBase}${url.slice(4)}`;
    return url;
  }

  if (url.startsWith('/uploads/')) {
    if (apiOrigin) return `${apiOrigin}${url}`;
    return url;
  }

  return url;
}

export function withPreviewParams(url: string, width: number, quality: number): string {
  const separator = url.includes('?') ? '&' : '?';
  return `${url}${separator}w=${width}&q=${quality}`;
}
